import React, { useEffect, useState } from "react";
import { KeyBlock } from "components/key/KeyBlock";
import PropTypes from "prop-types";
import { Position } from "@blueprintjs/core";
import './EmployeeCircleStatus.css';
import './Status.css';
import './StatusPanel.css';

const defaultArray = [];

export function EmployeeStatus({
    statusId = 0,
    typeId,
    isLoading = false,
    statusAttributeMappings = defaultArray,
    typeAttributeMappings = defaultArray,
    tooltipPosition = Position.TOP,
    ownershipId = 0,
    isRoaming = false
}) {

    const [tooltipText, setTooltipText] = useState("");
    const [statusColour, setStatusColour] = useState("");
    const [typeClassName, setTypeClassName] = useState("");

    useEffect(() => {
        if (statusId && typeId && statusAttributeMappings && typeAttributeMappings && statusAttributeMappings.length > 0 && typeAttributeMappings.length > 0) {
            const statusAttribute = statusAttributeMappings.find(o => {
                return o.id === statusId;
            });

            const typeAttribute = typeAttributeMappings.find(o => {
                return o.id === typeId;
            });

            if (statusAttribute) {
                if(statusAttribute.away === true) {
                    setStatusColour("#ff7454")
                } else if(statusAttribute.active === true) {
                   setStatusColour("#00c6b2");
                } else if(statusAttribute.inactive === true) {
                    setStatusColour("#ec2d6d");
                }
            }

            if (typeAttribute) {
                setTypeClassName(typeAttribute.agency === true ? "hollow" : "filled");
            }

            setTooltipText(`${statusAttribute.name} ${typeAttribute.name}`);
        }
    }, [statusId, typeId, statusAttributeMappings, typeAttributeMappings]);

    return (
        <div className="no-margin">
            <KeyBlock rounded={true} className={typeClassName} colours={statusColour} size={8} loading={isLoading} toolTipText={tooltipText} tooltipPosition={tooltipPosition} />
        </div>
    );
}

EmployeeStatus.propTypes = {
    statusId: PropTypes.number,
    typeId: PropTypes.number,
    isLoading: PropTypes.bool,
    statusAttributeMappings: PropTypes.array,
    typeAttributeMappings: PropTypes.array,
    isRoaming: PropTypes.bool,
    tooltipPosition: PropTypes.string
};